import styled from 'styled-components';
import { css } from 'styled-components';

export const TaskName = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	margin-bottom: 16px;
`;

export const CategoryName = styled.p`
	${({ theme }) => css`
		${{ ...theme.fonts.heading.sm }}
	`}
	margin-bottom: 16px;
`;

export const TaskTitle = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;

export const RiskLevel = styled.div`
	width: 127px;
	height: 32px;
	padding: 8px;
	border-radius: 4px;
	text-align: center;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;
export const CollapseContainer = styled.div`
	.ant-collapse {
		background-color: ${({ theme }) => theme.palette.secondary.white};
		border: 1px solid ${({ theme }) => theme.palette.secondary[200]};
		border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	}

	.ant-collapse-item {
		border-bottom: 1px solid ${({ theme }) => theme.palette.secondary[200]};

		&:last-child {
			border-bottom: none;
		}
	}

	.ant-collapse-header {
		padding: 16px 24px !important;
		background-color: ${({ theme }) => theme.palette.secondary[50]};
		border-radius: ${({ theme }) => theme.border.border_radius.br_lg}
			${({ theme }) => theme.border.border_radius.br_lg} 0 0 !important;

		&:hover {
			background-color: ${({ theme }) => theme.palette.secondary[100]};
		}

		.ant-collapse-arrow {
			color: ${({ theme }) => theme.colors.text};
			font-size: 16px;
		}
	}

	.ant-collapse-content {
		background-color: ${({ theme }) => theme.palette.secondary.white};
		border-top: 1px solid ${({ theme }) => theme.palette.secondary[200]};

		.ant-collapse-content-box {
			padding: 24px !important;
		}
	}

	.ant-collapse-item-active {
		.ant-collapse-header {
			background-color: ${({ theme }) => theme.palette.secondary[100]};
			border-radius: ${({ theme }) => theme.border.border_radius.br_lg}
				${({ theme }) => theme.border.border_radius.br_lg} 0 0 !important;
		}
	}
`;
